<template>

    <div>
        <div class="layui-card-header">
            <blockquote class="layui-elem-quote">
                认定申报<span
                    style="color: red;margin-left: 10px;">1.填报前请在个人信息中完善基本信息&nbsp;&nbsp;&nbsp;&nbsp;2.请仔细核对填写资料的正确性与完整性&nbsp;&nbsp;&nbsp;&nbsp;3.（带*</span><span
                    style="color: red;">为必填项！）</span>
            </blockquote>
        </div>
        <div class="layui-card-body">
            <table class="layui-table" style="margin: 0 auto;">
                <tbody>
                    <tr style="text-align: center;">
                        <td colspan="10" style="width: 450.00pt;
                                    text-align: center;
                                    font-size: 18px;
                                    font-weight: bold;">
                            职业技能等级认定
                        </td>
                    </tr>
                    <tr>
                        <td colspan="10" style="width: 450.00pt;
                                    color: black;
                                    font-size: 18px;font-weight: 600">
                            基础信息
                        </td>
                    </tr>
                    <tr style="height:28.00pt;">
                        <td style="height:28.00pt;">姓名</td>
                        <td colspan="1">
                            <el-input placeholder="请输入内容" v-model="userName" readonly>
                            </el-input>
                        </td>
                        <td>性别</td>
                        <td colspan="1">
                            <el-radio-group v-model="sex">
                                <el-radio label="1">男</el-radio>
                                <el-radio label="2">女</el-radio>
                            </el-radio-group>
                        </td>
                        <td>民族</td>
                        <td colspan="3">
                            <el-select v-model="nation" placeholder="请选择">
                                <el-option v-for="(item,index) in nationList" :key="index" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </td>
                        <td rowspan="3" style="text-align: center;">

                            <img v-if="affirmHeadPath" class="profile-image" :src="affirmHeadPath" alt="个人头像">

                        </td>
                    </tr>
                    <tr style="height:28.00pt;">
                        <td colspan="1" style="height:28.00pt;">联系方式</td>
                        <td colspan="2">
                            <el-input placeholder="请输入内容" v-model="phoneNumber" readonly>
                            </el-input>
                        </td>
                        <td style="height:28.00pt;">身份证号</td>
                        <td colspan="4">
                            <el-input placeholder="请输入内容" v-model="idCard" readonly>
                            </el-input>
                        </td>

                    </tr>
                    <tr style="height:28.00pt;">
                        <td style="height:28.00pt;">文化程度</td>
                        <td colspan="2">
                            <el-select v-model="education" placeholder="请选择">
                                <el-option v-for="(item,index) in educationList" :key="index" :label="item"
                                    :value="item"> </el-option>
                            </el-select>
                        </td>
                        <td colspan="1">政治面貌</td>
                        <td colspan="4">
                            <div class="layui-input-inline" style="width: 210px">
                                <el-select v-model="politic_countenance" placeholder="请选择">
                                    <el-option v-for="(item,index) in politic_countenanceList" :key="index"
                                        :label="item" :value="item"> </el-option>
                                </el-select>
                            </div>
                        </td>
                    </tr>
                    <tr style="height:28.00pt;">
                        <td colspan="1"><span style="color: red;">*</span>报名点所在地区</td>
                        <td colspan="2">
                            <el-select v-model="registrationPlace" placeholder="请选择">
                                <el-option v-for="(item,index) in registrationPlaceList" :key="index" :label="item.name"
                                    :value="item.value"> </el-option>
                            </el-select>
                        </td>
                        <td style="height:28.00pt;"><span style="color: red;">*</span>考生来源</td>
                        <td colspan="6">
                            <div class="layui-form-item" style="margin-bottom: 0px;">
                                <div class="layui-input-inline" style="width: 210px;margin-right: 14px;">
                                    <el-cascader v-model="candidatesSource" :options="candidatesSourceList"
                                        :props="{ expandTrigger: 'hover' }">
                                    </el-cascader>
                                </div>
                            </div>
                        </td>

                    </tr>
                    <tr>
                        <td>工作时间</td>
                        <td colspan="2">
                            <el-date-picker style="width:203px" v-model="professionTime" align="center" type="date"
                                placeholder="选择日期" :picker-options="pickerOptions">
                            </el-date-picker>
                        </td>
                        <td colspan="1">原技术等级</td>
                        <td colspan="3">
                            <div class="layui-input-inline" style="width: 210px">
                                <div class="layui-unselect layui-form-select">
                                    <el-select v-model="historyWorkTypeLevel" placeholder="请选择">
                                        <el-option v-for="(item,index) in historyWorkTypeLevelList" :key="index"
                                            :label="item.name" :value="item.value"> </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </td>
                        <td colspan="1"><span style="color: red;">*</span>从事本工种年限</td>
                        <td colspan="1">
                            <el-input placeholder="工种年限" v-model="professionYears">
                            </el-input>
                        </td>

                    </tr>
                    <tr style="height:15.90pt;">
                        <td style="height:30.30pt;">原职业(工种）</td>
                        <td colspan="2">
                            <el-select v-model="historyWorkTypeId" placeholder="请选择">
                                <el-option v-for="(item,index) in historyWorkTypeIdList" :key="index" :label="item.name"
                                    :value="item.value"> </el-option>
                            </el-select>
                        </td>
                        <td colspan="1">原证书编号</td>
                        <td colspan="3">
                            <el-input style="width:203px" placeholder="请输入原证书编号" v-model="certificateNum">
                            </el-input>
                        </td>
                        <td style="height:30.30pt;">原证书取得(时间）</td>
                        <td colspan="1">
                            <el-date-picker style="width:140px" v-model="historyWorkTypeDate" type="date"
                                placeholder="选择日期" :picker-options="pickerOptions">
                            </el-date-picker>

                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="layui-table" style="margin: 24px auto 0px; position: static;">
                <tbody>
                    <tr>
                        <td colspan="10" style="width: 450.00pt;font-size: 18px;color: black;font-weight: 600">
                            申报信息
                        </td>
                    </tr>
                    <tr style="height:22.00pt;">
                        <td style="height:22.00pt;"><span style="color: red;">*</span>当前认定职业</td>
                        <td colspan="2">
                            <el-select v-model="workTypeId" placeholder="请选择" @change="currentIdentifiedOccupationChange">
                                <el-option v-for="(item,index) in historyWorkTypeIdList" :key="index" :label="item.name"
                                    :value="item.value"> </el-option>
                            </el-select>
                        </td>
                        <td style="height:28.00pt;"><span style="color: red;">*</span>鉴定分类</td>
                        <td colspan="3">
                            <el-select v-model="declareClassification" placeholder="请选择">
                                <el-option v-for="(item,index) in declareClassificationList" :key="index" :label="item"
                                    :value="item"> </el-option>
                            </el-select>
                        </td>
                        <td colspan="1"><span style="color: red;">*</span>当前认定等级</td>
                        <td colspan="1">
                            <el-select v-model="workTypeLevelState" :disabled="false" placeholder="请选择"
                                style="width: 140px;">
                                <el-option v-for="(item,index) in historyWorkTypeLevelList" :key="index"
                                    :label="item.name" :value="item.value"> </el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr style="height:22.00pt;">
                        <td>证书是否邮寄</td>
                        <td colspan="2">
                            <el-radio-group v-model="mailOrNot">
                                <el-radio label="2">是</el-radio>
                                <el-radio label="1">否</el-radio>
                            </el-radio-group>
                        </td>
                        <td colspan="1" style="height:28.00pt;">证书邮寄地址</td>
                        <td colspan="6">
                            <el-input placeholder="如需要邮寄，请填写邮寄地址" v-model="mailingAddress">
                            </el-input>
                        </td>
                    </tr>
                    <tr style="height:22.00pt;">
                        <td colspan="2" style="height:22.00pt;">工作单位及详细通信地址</td>
                        <td colspan="8">
                            <el-input placeholder="请输入工作单位及详细通讯地址" v-model="detailedAddress">
                            </el-input>
                        </td>
                    </tr>
                    <tr style="height:22.00pt;">
                        <!-- <td colspan="2" style="height:22.00pt;">何时何校何专业毕(结)业</td>
                        <td colspan="8">
                            <el-input placeholder="请输入何时何校何专业毕（结）业" v-model="ex1">
                            </el-input>
                        </td> -->

                        <td style="height:22.00pt;">毕业院校</td>
                        <td colspan="2">
                            <el-input placeholder="请输入毕业院校" v-model="graduationSchool">
                            </el-input>
                        </td>
                        <td style="height:28.00pt;"><span style="color: red;">*</span>毕业专业</td>
                        <td colspan="3">
                            <el-select v-model="graduationMajor" placeholder="请选择">
                                <el-option v-for="(item,index) in declareMajorList" :key="index" :label="item.id"
                                    :value="item.majorName"> </el-option>
                            </el-select>
                        </td>
                        <td colspan="1">毕业时间</td>
                        <td colspan="1">
                            <el-input placeholder="请输入毕业时间" v-model="graduationTime">
                            </el-input>
                        </td>

                    </tr>
                    <tr style="height:22.00pt;">
                        <td colspan="2" style="height:22.00pt;">何时何地再培训毕(结)业</td>
                        <td colspan="8">
                            <el-input placeholder="请输入何时何地再培训毕（结）业" v-model="ex2">
                            </el-input>
                        </td>
                    </tr>
                    <tr style="height:22.00pt;">
                        <td colspan="2" style="height:22.00pt;"><span style="color: red;">*</span>本人承诺</td>
                        <td colspan="8">
                            <el-input placeholder="本人承诺在XX公司工作X年，XX职位，XX级别" v-model="personalCommitment">
                            </el-input>
                        </td>
                    </tr>
                    <tr style="height: 192px;">
                        <td style="height:75.00pt;">本人简历</td>
                        <td colspan="9">
                            <div id="userResume-editor" class="edui-default">
                                <quill-editor ref="text" v-model="content" class="myQuillEditor"
                                    :options="editorOption" />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="9" class="serviceAgreement" style="padding-left: 206px;">
                            <div>
                                <el-checkbox v-model="checked"></el-checkbox>
                                <a target="_blank" @click="openContactInformation" class="serviceA"
                                    style="cursor: pointer;">我已阅读并同意《职业技能等级认定考试网上报名协议》</a>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="state == 2" style="height:22.00pt;">
                        <td colspan="2" style="height:22.00pt;"><span style="color: red;">*</span>综改区认定标识码</td>
                        <td colspan="8">
                            <el-input placeholder="请输入山西转型综合改革示范区职业技能认定位置标识码"
                                v-model="heddleChangeAreaIdentificationCode">
                            </el-input>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="layui-form-item" style="text-align: center;margin-top: 15px;">
                <a class="layui-btn layui-btn-sm" @click="instantlySave()">确定保存</a>
                <a class="layui-btn layui-btn-sm cancle-declare-btn"
                    style="background-color: #f4f4f4;color: #333;">取消返回</a>
            </div>
            <el-dialog title='协议' :visible.sync="dialogTableVisible2" style="margin-top: 0vh;height: auto" width="58%"
                :center="true">

                <div
                    style="background-color: blanchedalmond; width: 842px;height: 70%;border: 1px solid #e8e8e8;text-align: justify">
                    <div style="font-size: 22px;font-weight: 600;margin-bottom: 13px;
                    border-bottom: 1px dashed #e8e8e8;
                    padding-bottom: 25px;text-align: center">
                        《职业技能等级认定考试网上报名协议》
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;font-weight: 600">
                        尊敬的考生:
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;text-indent: 2em">
                        您好！
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;text-indent: 2em">
                        欢迎您使用职业技能等级认定平台网上报名系统，为顺利完成考试报名，请您认真阅读并遵守以下条款：
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;text-indent: 2em">
                        1.网上报名系统的所有权归职业技能等级认定中心所有，考生完全同意以下条款，才可以进行网上报名。
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;text-indent: 2em">
                        2.考生不得以他人身份进行报名，否则由此引发的纠纷，由考生本人负责。
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;text-indent: 2em">
                        3.考生应当仔细阅读报考条件，符合报考条件者方可报考，如报名后不能通过资格审核，则考生不能参加考试。
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;text-indent: 2em">
                        4.考生所填写的个人信息资料应当真实准确，填报后认真检查，由于个人填写错误影响到正常参加考试，由考生本人承担全部责任。
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;text-indent: 2em">
                        5.考生在“提交”报名信息后，即构成考生对所提交资料内容真实性、准确性、合法性的承诺，不得再以任何方式修改报名信息。
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;text-indent: 2em">
                        6.考生在“提交”报名信息后，即表示考生知悉并且自愿遵守职业技能等级认定平台关于考试报名、考试方式、考试系统、考试实施、考试信息披露、成绩复核、职业技能等级证书管理等考试管理制度及其具体组织实施方案。
                    </div>
                    <div style="font-size: 16px;font-family: 宋体;text-indent: 2em;font-weight: 600">
                        7.考生网上支付成功后，如因系统错误导致多收费或错收费，或因考生误操作导致多支付，考生可申请退费。除此之外，考生不得以任何其他理由申请退费。
                    </div>
                </div>
            </el-dialog>

            <div class="cu-modal" :class="contactInformationFlag == 'contactInformationFlag' ? 'show' : ''"
                @click="closeContactInformation">

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {
        },
        data() {
            return {
                declareMajorList:[],
                graduationMajor:'',//毕业专业
                graduationSchool:'',//毕业院校
                graduationTime:'',//毕业时间

                affirmHeadPath: '',//头像回显路径
                dialogTableVisible2: false,
                heddleChangeAreaIdentificationCode: '',//山西转型综合改革示范区职业技能等级认定标识码
                state: 0, // 1 正常登录后从首页进来   2 综改区报名进来的
                checked: false,
                contactInformationFlag: '',
                editorOption: {
                    modules: {
                        toolbar: [
                            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                            /* ["blockquote", "code-block"] */, // 引用  代码块
                            /* [{ header: 1 }, { header: 2 }], // 1、2 级标题
                            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
                            [{ script: "sub" }, { script: "super" }], // 上标/下标
                            [{ indent: "-1" }, { indent: "+1" }], // 缩进
                            // [{'direction': 'rtl'}],                         // 文本方向
                            [{ size: ["small", false, "large", "huge"] }], // 字体大小
                            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
                            [{ font: [] }], // 字体种类
                            [{ align: [] }], // 对齐方式
                            ["clean"] */ // 清除文本格式
                        ], //工具菜单栏配置
                    },
                    placeholder: '请在这里添加产品描述', //提示
                    readyOnly: false, //是否只读
                    theme: 'snow', //主题 snow/bubble
                    syntax: true, //语法检测
                },
                content: '',
                sex: '',
                mailOrNot: '1',//证书 是否邮寄 2是 1否
                mailingAddress: '',// 证书邮寄地址
                detailedAddress: '',//工作地址详细通讯地址
                ex1: '',//何时何校何转业 毕业
                ex2: '',//请输入何时何地再培训毕（结）业
                personalCommitment: '',//本人承诺在XX公司工作X年，XX职位，XX级别
                userName: this.$storage.get('declareUser').userName,
                phoneNumber: this.$storage.get('declareUser').telephone,
                idCard: this.$storage.get('declareUser').idCard,
                nation: '',
                nationList: ['汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族', '满族'
                    , '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族', '佤族', '畲族', '高山族'
                    , '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族'
                    , '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族'
                    , '德昂族', '保安族', '裕固族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
                education: '',
                educationList: ['博士', '研究生', '本科', '专科', '高中', '初中', '小学', '其他'],
                politic_countenance: '',
                politic_countenanceList: ['中共党员', '中共预备党员', '共青团员', '民革党员', '民盟盟员', '民建会员', '民进会员'
                    , '农工党党员', '致公党党员', '九三学社社员', '台盟盟员', '无党派人士', '群众', '其他'],
                registrationPlace: '',
                registrationPlaceList: [{ name: '太原', value: '1' }, { name: '大同', value: '2' }, { name: '忻州', value: '3' }
                    , { name: '阳泉', value: '4' }, { name: '吕梁', value: '5' }, { name: '晋中', value: '6' }, { name: '临汾', value: '7' }
                    , { name: '长治', value: '8' }, { name: '晋城', value: '9' }, { name: '运城', value: '10' }, { name: '朔州', value: '11' }],
                candidatesSource: [],
                candidatesSourceList: [
                    {
                        value: '企业职工', label: '企业职工', children: [{ value: '国有企业', label: '国有企业' }, { value: '私营企业', label: '私营企业' }
                            , { value: '个体企业', label: '个体企业' }, { value: '外商投资', label: '外商投资' }, { value: '港澳台商投资', label: '港澳台商投资' }]
                    },
                    {
                        value: '院校学生', label: '院校学生', children: [{ value: '职业高中', label: '职业高中' }, { value: '普通技工学校', label: '普通技工学校' }
                            , { value: '高级技工学校', label: '高级技工学校' }, { value: '技师学院', label: '职业技术学院' }, { value: '普通中专', label: '普通中专' }
                            , { value: '普通高中', label: '普通高中' }, { value: '普通大专', label: '普通大专' }, { value: '普通大学', label: '普通大学' }
                            , { value: '研究生院', label: '研究生院' }, { value: '其他', label: '其他' }]
                    },
                    { value: '社会人员', label: '社会人员', children: [{ value: '社会人员', label: '社会人员' }] },
                    { value: '机关事业单位', label: '机关事业单位', children: [{ value: '机关事业单位', label: '机关事业单位' }] }],
                professionTime: '',//工作时间
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                historyWorkTypeLevel: '',
                historyWorkTypeLevelList: [{ name: '高级技师', value: 1 }, { name: '技师', value: 2 }, { name: '三级（高级工）', value: 3 },
                { name: '四级（中级工）', value: 4 }, { name: '五级（初级工）', value: 5 }],
                professionYears: '',//工种年限
                historyWorkTypeId: '',
                historyWorkTypeIdList: [],
                certificateNum: '',
                historyWorkTypeDate: '',
                workTypeId: '',
                declareClassification: '',
                declareClassificationList: ['初次鉴定', '晋级鉴定', '补考鉴定'],
                workTypeLevelState: 0
            }
        },
        created() {

            //console.log("=============" + this.$route.params.workTypeLevelState);

            //console.log("=============" + this.$route.params.state);

            this.workTypeLevelState = parseInt(this.$route.params.workTypeLevelState);

            this.state = this.$route.params.state;

            //加载职业工种
            this.loadworkTypeDate();
            this.loadData();
        },
        mounted() {

        },
        methods: {
            currentIdentifiedOccupationChange(){
                let parames = new URLSearchParams();
                parames.append('workTypeId', this.workTypeId) 
                 this.$axios.post(this.serverUrl + '/dict/getMajorList', parames).then(resp => {


                    if (resp.data.code === 1) {

                        this.declareMajorList = resp.data.data;

                    }



                }).catch(err => {
                    console.log(err);
                })

            },
            loadworkTypeDate() {

                var params = new URLSearchParams();

                console.log("declare===========" + this.$storage.get('declareUser'));
                params.append('userType', '1');
                params.append('groupType', '1');
                params.append('workTypeGradeOpen', this.$route.params.workTypeLevelState);
                this.$axios.post(this.serverUrl + '/getGroupList', params).then(resp => {

                    resp.data.data.forEach(element => {
                        let historyWork = {
                            name: '',
                            value: ''
                        }
                        historyWork.name = element.workTypeName;
                        historyWork.value = element.workTypeId;
                        this.historyWorkTypeIdList.push(historyWork);

                    });

                }).catch(err => {
                    this.$message('工种列表加载失败！');
                })

            },
            loadData() {
                let parames = new URLSearchParams();
                parames.append('idCard', this.$storage.get('declareUser').idCard);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/getDeclareUserData', parames).then(resp => {
                    //this.serverUrl
                    this.affirmHeadPath = this.serverUrl + this.prefiexUrl + resp.data.data.headPath;


                    this.sex = resp.data.data.sex.toString();
                    this.education = resp.data.data.education;
                    this.major = resp.data.data.major;
                    this.politic_countenance = resp.data.data.politic_countenance;
                    this.nation = resp.data.data.nation;
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            },
            //date 转String
            dateStringTransition(date) {
                var year = date.getFullYear(); //获取完整的年份(4位,1970-????)
                var month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
                var day = date.getDate(); //获取当前日(1-31)
                if (month < 10) {
                    month = "0" + month;
                }
                if (day < 10) {
                    day = "0" + day;
                }
                return year + "-" + month + "-" + day + " 00:00:00";
            },
            //立即认定
            instantlySave() {
                if (this.registrationPlace === '') {

                    this.$message({
                        message: '请选择报名所在地！',
                        type: 'warning'
                    });

                    return false;
                } else if (this.candidatesSource === '') {
                    this.$message({
                        message: '请选择考生来源!',
                        type: 'warning'
                    });
                    return false;
                } else if (this.professionYears === '') {
                    this.$message({
                        message: '请填写从事本工种年限！',
                        type: 'warning'
                    });

                    return false;
                } else if (this.workTypeId === '') {
                    this.$message({
                        message: '请填写当前认定职业！',
                        type: 'warning'
                    });

                    return false;
                } else if (this.declareClassification === '') {
                    this.$message({
                        message: '请选择鉴定分类！',
                        type: 'warning'
                    });

                    return false;
                } else if (this.workTypeLevelState === '') {
                    this.$message({
                        message: '请选择当前认定等级！',
                        type: 'warning'
                    });

                    return false;
                } else if (this.graduationMajor === '') {
                    this.$message({
                        message: '请选择毕业专业！',
                        type: 'warning'
                    });

                    return false;
                } else if (this.personalCommitment === '') {
                    this.$message({
                        message: '请填写本人承诺！',
                        type: 'warning'
                    });

                    return false;
                } else if (!this.checked && this.state == 1) {
                    this.$message({
                        message: '请同意职业技能等级认定考试网上报名协议',
                        type: 'warning'
                    });
                    return false;
                } else if (!this.checked && this.state == 2) {
                    this.$message({
                        message: '请同意综改区职业技能等级认定考试网上报名协议',
                        type: 'warning'
                    });
                    return false;
                } else if (this.heddleChangeAreaIdentificationCode === '' && this.state == 2) {
                    this.$message({
                        message: '请输入综改区认定标识码！',
                        type: 'warning'
                    });
                    return false;
                } else if (this.heddleChangeAreaIdentificationCode != this.declareCode && this.state == 2) {
                    this.$message({
                        message: '输入的综改区认定标识码不正确！',
                        type: 'warning'
                    });
                    return false;
                }


                const loading = this.$loading({
                    lock: true,
                    text: '信息提交中，请稍后...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

               /*  let experienceDesc = '';

                if (this.ex1 != '' && this.ex2 != '') {
                    experienceDesc = "1-" + this.ex1 + "," + "2-" + this.ex2;
                }

                if (this.ex1 != '' && this.ex2 === '') {
                    experienceDesc = "1-" + this.ex1;
                }

                if (this.ex2 != '' && this.ex1 === '') {
                    experienceDesc = "2-" + this.ex2;
                } */
                let parames = new URLSearchParams();
                parames.append('userName', this.userName);
                parames.append('sex', this.sex);

                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('idCard', this.idCard);
                parames.append('registrationPlace', this.registrationPlace);//报名所在地
                parames.append('candidatesSource', this.candidatesSource[0]);//考生来源
                parames.append('candidatesSourceSon', this.candidatesSource[1]);//考生来源子集
                if (this.professionTime != '') {
                    parames.append('professionTime', this.dateStringTransition(this.professionTime));//工作时间
                }
                parames.append('historyWorkTypeLevel', this.historyWorkTypeLevel); //原技术等级
                parames.append('professionYears', this.professionYears);  //工种年限
                parames.append('historyWorkTypeId', this.historyWorkTypeId);  //原职业工种
                parames.append('certificateNum', this.certificateNum); //原证书编号
                if (this.professionTime != '') {
                    parames.append('historyWorkTypeDate', this.dateStringTransition(this.historyWorkTypeDate)); //原证书取得时间
                }
                parames.append('workTypeId', this.workTypeId);  //当前认定职业工种
                parames.append('declareClassification', this.declareClassification); //鉴定分类
                parames.append('workTypeLevelState', this.workTypeLevelState) //当前申报等级

                parames.append('graduationSchool', this.graduationSchool) //毕业院校
                parames.append('graduationMajor', this.graduationMajor) //毕业专业
                parames.append('graduationTime', this.graduationTime) //毕业时间
                parames.append('trainingGraduation', this.ex2);  

                parames.append('mailOrNot', this.mailOrNot);  //证书是否邮寄
                parames.append('mailingAddress', this.mailingAddress); //证书邮寄地址
               
                parames.append('detailedAddress', this.detailedAddress);//工作单位及详细通信地址
                parames.append('personalCommitment', this.personalCommitment); //个人承诺
                parames.append('userResume', this.content);//本人简历

                if (this.state == 2) {
                    //state 为2 是综改区认定
                    parames.append('declareCode', this.heddleChangeAreaIdentificationCode);//认定标识码    
                }

                this.$axios.post(this.serverUrl + '/addDeclare', parames).then(resp => {

                    if (resp.data.code === 1) {

                        loading.close();

                        if (this.state == 2) {

                            this.$router.push({ path: '/affirmUploadData1/' + this.workTypeLevelState + "/2" });
                        } else {
                            this.$router.push({ path: '/affirmUploadData/' + this.workTypeLevelState + "/1" });
                        }


                        this.$parent.leftBeginAffirm(4);
                    } else if (resp.data.code === 3) {
                        this.$message({
                            message: '当前申报职业等级已存在审核中或已通过审核的数据，请勿重复提交！',
                            type: 'warning'
                        });
                    }


                }).catch(err => {
                    console.log(err);
                })
            },

            closeContactInformation() {
                this.dialogTableVisible2 = false;
            },
            openContactInformation() {
                this.dialogTableVisible2 = true;
            }
        }
    }
</script>

<style scoped>
    div /deep/ .el-upload__input {
        display: none !important;
    }

    div /deep/ .el-upload-dragger {
        background-color: #fff;
        border: 0px dashed #d9d9d9 !important;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: auto !important;
        height: auto !important;
        text-align: inherit !important;
        position: relative;
        overflow: hidden;
    }

    div /deep/ .ql-editor {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        line-height: 1.42;
        height: 160px !important;
        outline: none;
        overflow-y: auto;
        padding: 12px 15px;
        -o-tab-size: 4;
        tab-size: 4;
        -moz-tab-size: 4;
        text-align: left;
        white-space: pre-wrap;
        word-wrap: break-word;
    }

    .layui-btn+.layui-btn {
        margin-left: 10px;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-sm {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 12px;
    }

    .layui-form-item {
        margin-bottom: 15px;
        clear: both;
        *zoom: 1;
    }

    .el-checkbox__input {
        cursor: pointer;
        outline: 0;
        /* line-height: 1; */
        vertical-align: unset;
    }

    .cu-modal.show {
        opacity: 1;
        transition-duration: 0.1s;
        transform: scale(1);
        pointer-events: auto;
    }

    .cu-modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        opacity: 0;
        outline: 0;
        z-index: 999;
        text-align: center;
        transform: scale(100);
        backface-visibility: hidden;
        background: rgba(0, 0, 0, 0.6);
        transition: all 2 ease 2;
        pointer-events: none;
    }

    .ql-toolbar.ql-snow+.ql-container.ql-snow {
        border-top: 0px;
        height: 120px;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }

    .el-select .el-input__inner:focus {
        border-color: #969696;
    }

    .el-select .el-input.is-focus .el-input__inner {
        border-color: #969696;
    }

    .el-radio-button__inner,
    .el-radio-group {
        display: inline-block;
        line-height: 1;
        vertical-align: middle;
        display: flex;
    }

    .el-radio__label {
        font-size: 14px;
        padding-left: 5px;
    }

    .layui-table td {
        position: relative;
        padding: 9px 9px;
        min-height: 20px;
        line-height: 20px;
        font-size: 14px;
        width: 96px !important;
        border-width: 1px;
        border-style: solid;
        border-color: #e6e6e6;
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: #5FB878;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border-color: #5FB878;
        background: #5FB878;
    }

    .layui-form-radio {
        line-height: 28px;
        margin: 6px 10px 0 0;
        padding-right: 10px;
        cursor: pointer;
        font-size: 0;
    }

    .lrspb .layui-form-radio {
        margin: 6px 0px 0 0;
        padding-right: 2px;
    }

    button,
    input,
    optgroup,
    option,
    select,
    textarea {
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        font-weight: inherit;
        outline: 0;
    }

    .lrspb .ux-input_base {
        height: 33px;
        width: 89%;
    }

    .layui-table {
        width: 100%;
        background-color: #fff;
        color: #666;
    }


    .layui-card-body {
        position: relative;
        padding: 10px 15px;
        line-height: 24px;
    }

    .layui-card-header {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding: 0 15px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        border-radius: 2px 2px 0 0;
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/beginAffirm.vue